export const LEAVE_TYPE_LIST_REQUESTED = "LEAVE_TYPE_LIST_REQUESTED";
export const LEAVE_TYPE_LIST_SUCCEEDED = "LEAVE_TYPE_LIST_SUCCEEDED";
export const LEAVE_TYPE_LIST_FAILED = "LEAVE_TYPE_LIST_FAILED";

export const LEAVE_TYPE_CREATE_REQUESTED = "LEAVE_TYPE_CREATE_REQUESTED";
export const LEAVE_TYPE_CREATE_SUCCEEDED = "LEAVE_TYPE_CREATE_SUCCEEDED";
export const LEAVE_TYPE_CREATE_FAILED = "LEAVE_TYPE_CREATE_FAILED";

export const LEAVE_TYPE_UPDATE_REQUESTED = "LEAVE_TYPE_UPDATE_REQUESTED";
export const LEAVE_TYPE_UPDATE_SUCCEEDED = "LEAVE_TYPE_UPDATE_SUCCEEDED";
export const LEAVE_TYPE_UPDATE_FAILED = "LEAVE_TYPE_UPDATE_FAILED";

export const LEAVE_TYPE_DELETE_REQUESTED = "LEAVE_TYPE_DELETE_REQUESTED";
export const LEAVE_TYPE_DELETE_SUCCEEDED = "LEAVE_TYPE_DELETE_SUCCEEDED";
export const LEAVE_TYPE_DELETE_FAILED = "LEAVE_TYPE_DELETE_FAILED";

export default {
	LEAVE_TYPE_LIST_REQUESTED,
	LEAVE_TYPE_LIST_SUCCEEDED,
	LEAVE_TYPE_LIST_FAILED,
	LEAVE_TYPE_CREATE_REQUESTED,
	LEAVE_TYPE_CREATE_SUCCEEDED,
	LEAVE_TYPE_CREATE_FAILED,
	LEAVE_TYPE_UPDATE_REQUESTED,
	LEAVE_TYPE_UPDATE_SUCCEEDED,
	LEAVE_TYPE_UPDATE_FAILED,
	LEAVE_TYPE_DELETE_REQUESTED,
	LEAVE_TYPE_DELETE_SUCCEEDED,
	LEAVE_TYPE_DELETE_FAILED
};
